export const BUTTON_PADDING_HORIZONTAL = 8
export const BUTTON_PADDING_VERTICAL = 4

export const BUTTON_MIN_WIDTH = 64
export const BUTTON_MIN_HEIGHT = 36
export const BUTTON_SMALL_MIN_WIDTH = 64
export const BUTTON_SMALL_MIN_HEIGHT = 32
export const BUTTON_LARGE_MIN_WIDTH = 112
export const BUTTON_LARGE_MIN_HEIGHT = 40
